/**
 * Smoothly scroll to an element by its id.
 * @param {string} id  — element id without '#'
 * @param {number} [offset=80] — px to subtract (e.g. fixed header height)
 */
export function scrollToId(id, offset = 80) {
  const el = document.getElementById(id)
  if (!el) return
  const top = el.getBoundingClientRect().top + window.scrollY - offset
  window.scrollTo({ top, behavior: 'smooth' })
}

/**
 * Scroll to the very top of the page.
 */
export function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}
